angular.module('core')
  .controller('VerifyCancelRtiReportModalController', ['$scope', '$modalInstance', 'focusConcept', 'studentName', function($scope, $modalInstance, focusConcept, studentName) {
      // @INFO: Helpful info on how angular modals should work
      // http://stackoverflow.com/questions/19743299/what-is-the-difference-between-dismiss-a-modal-and-close-a-modal-in-angular
      // http://plnkr.co/edit/xMTr78WJQbKyHsA53gyv?p=preview
      $scope.ok = function () {
          $modalInstance.close();
      };

      $scope.cancel = function() {
          $modalInstance.dismiss('canceled by user');
      };

      $scope.topic_name = focusConcept;
      $scope.student_name = studentName;

  }]);
